import type { CookieOptions } from '#app'

/** https://nuxt.com/docs/api/composables/use-cookie */
export const useServiceCookie = <T = string>(
  name: string,
  option?: CookieOptions<T>,
) => {
  const config = useRuntimeConfig()
  const isLocal = config.public.configEnv === 'local'

  const COOKIE_PATH = '/'
  const COOKIE_OPTION_DEFAULT: CookieOptions<T> = {
    sameSite: 'none',
    secure: true,
  }
  const COOKIE_OPTION_LOCAL: CookieOptions<T> = {
    sameSite: 'strict',
    secure: true,
  }

  const mergedOptions: CookieOptions<T> = {
    ...(isLocal ? COOKIE_OPTION_LOCAL : COOKIE_OPTION_DEFAULT),
    path: COOKIE_PATH,
    domain: config.public.cookieDomain,
    ...option,
  }

  const cookie = useCookie<T | null>(name, {
    ...mergedOptions,
    readonly: false,
  })

  const set = (value: T) => {
    cookie.value = value
  }

  const get = () => {
    return cookie.value
  }

  const has = () => {
    return get() !== undefined
  }

  const remove = () => {
    cookie.value = null
  }

  return {
    set,
    get,
    has,
    remove,
  }
}
